const pageTitles = {
  30308: {
    'brands:fingerlings': 'Fingerlings Monkey Toys | Argos',
    'brands:furreal': 'FurReal Toys | Argos',
    'brands:little-live-pets': 'Little Live Pets | Argos',
    'brands:minecraft': 'Minecraft Teddy Bears and Soft Toys | Argos',
    'brands:vtech': 'Vtech Soft Toys | Argos'
  },
  30333: {
    'type:quad-skates': 'Quad Skates | Argos'
  },
  30334: {
    'type:electric': 'Electric Scooters for Kids | Argos',
    'type:stunt': 'Stunt Scooters for Kids | Argos',
    'type:three-wheeled': 'Three Wheeled Scooters for Kids | Argos',
    'type:two-wheeled': 'Two Wheeled Scooters for Kids | Argos'
  },
  30344: {
    'brands:gazillion': 'GAZILLION Bubble Solution | Argos'
  },
  30346: {
    '': 'Outdoor Kids Ball Games | Argos',
    'brands:swingball': 'Swingball Sets | Argos'
  },
  30347: {
    '': 'Kids Basketball Hoop Sets | Argos'
  },
  30349: {
    '': 'Kids Footballs and Goals | Argos'
  },
  30352: {
    'age-range:child-%281%252D2-years%29': 'Baby Paddling Pools (for 1-2 Year Olds) | Argos',
    'age-range:child-%283%252D4-years%29': 'Paddling Pools for 3-4 Year Olds | Argos',
    'age-range:child-%285%252D8-years%29': 'Paddling Pools for 5-8 Year Olds | Argos',
    'brands:unicorn': 'Unicorn Paddling Pools | Argos',
    'width-(cm):132': '4ft Paddling Pools | Argos',
    'width-(cm):183': '6ft Paddling Pools | Argos',
    'width-(cm):244': '8ft Paddling Pools | Argos',
    'width-(cm):279': '9ft Paddling Pools | Argos',
    'width-(cm):305': '10ft Paddling Pools | Argos',
    'width-(cm):366': '12ft Paddling Pools | Argos'
  },
  30353: {
    'brands:air-hawk': 'Air Hawk Pool Pumps | Argos',
    'brands:clearwater': 'Clearwater Pool Chemicals | Argos',
    'type:air-pump': 'Manual and Electric Paddling Pool Pumps | Argos'
  },
  30354: {
    'brands:chad-valley': 'Chad Valley Water Guns | Argos',
    'brands:hydroclash': 'HydroClash Water Guns | Argos',
    'brands:zuru-bunch-o-balloons': 'ZURU BUNCH O BALLOONS | Argos',
    'brands:zuru': 'Zuru Water Guns | Argos',
    'brands:zuru-x%252Dshot': 'ZURU X-SHOT Water Guns | Argos'
  },
  30356: {
    'brands:chad-valley': 'Chad Valley Sand Tables and Water  Tables | Argos'
  },
  30357: {
    'age-range:child-%281%252D2-years%29': 'Baby Sandpits for 1-2 Year Olds | Argos'
  },
  30362: {
    'age-range:child-%281%252D2-years%29': 'Playhouses for 1-2 Year Olds | Argos',
    'age-range:child-%283%252D4-years%29': 'Playhouses for 3-4 Year Olds | Argos',
    'brands:plum': 'Plum Playhouses | Argos',
    'type:plastic': 'Plastic Playhouses for Kids | Argos',
    'type:wooden': 'Wooden Playhouses | Argos'
  },
  30366: {
    'type:outdoor-games': 'Outdoor Ball Pits | Argos'
  },
  30367: {
    'width-(ft):10': '10ft Trampolines | Argos',
    'width-(ft):12': '12ft Trampolines | Argos',
    'width-(ft):14': '14ft Trampolines | Argos',
    'width-(ft):2': '2ft Trampolines | Argos',
    'width-(ft):3': '3ft Trampolines | Argos',
    'width-(ft):4': '4ft Trampolines | Argos',
    'width-(ft):6': '6ft Trampolines | Argos',
    'width-(ft):8': '8ft Trampolines | Argos',
    'brands:paw-patrol': 'PAW Patrol Trampolines | Argos',
    'shape:rectangular': 'Rectangular Trampolines | Argos',
    'shape:round': 'Round Trampolines | Argos',
    'shape:square': 'Square Trampolines | Argos',
    'age-range:child-%285%252D8-years%29': 'Trampolines for 5-8 Year Olds | Argos',
    'age-range:child-%281%252D2-years%29': 'Trampolines for Babies and Toddlers (1-2 Year Olds) | Argos',
    'suitability:indoor/type:trampolines': 'Indoor Trampolines for Kids | Argos'
  },
  30368: {
    'brands:sportspower': 'Sportspower Trampoline Parts | Argos',
    'type:accessory-kits': 'Trampoline Accessory Kits | Argos'
  },
  30369: {
    'age-range:child-%281%252D2-years%29': 'Swings for 1-2 Year Olds | Argos',
    'age-range:child-%283%252D4-years%29': 'Swings for 3-4 Year Olds | Argos'
  },
  30373: {
    'brands:funko': 'Funko Pop! | Argos',
    'brands:imaginext': 'Imaginext Figures | Argos',
    'brands:micro-toybox': 'Micro Toybox | Argos',
    'brands:ninja-kidz': 'Ninja Kidz Playsets and Figures | Argos',
    'brands:real-littles': 'Real Littles Playsets and Figures | Argos',
    'brands:zuru-5-surprise': 'Zuru 5 Surprise Playsets and Figures | Argos',
    'brands:zuru-mini-brands': 'Zuru Mini Brands Playsets and Figures | Argos',
    'brands:zuru-robo-alive': 'Zuru Robo Alive Playsets and Figures | Argos',
    'character:superman': 'Superman Playsets and Figures | Argos',
    'brands:transformers/character:optimus-prime': 'Optimus Prime Toys | Argos'
  },
  30375: {
    'age-range:child-%283%252D4-years%29': 'Musical Toys for 3-4 Year Olds | Argos'
  },
  30377: {
    'age-range:child-%285%252D8-years%29': 'Discovery and Science Toys for 5-8 Year Olds | Argos',
    'age-range:child-%289%252D12-years%29': 'Discovery and Science Toys for 9-12 Year Olds | Argos',
    'brands:john-adams': 'John Adams Toys | Argos',
    'brands:national-geographic': 'National Geographic Toys | Argos',
    'brands:spy-x': 'Spy X Toys | Argos',
    'type:engineering': 'Engineering Toys | Argos',
    'type:geography': 'Geography Toys | Argos'
  },
  30379: {
    'interest:dinosaurs': 'LEGO Dinosaur Sets | Argos',
    'interest:dolls-house': 'LEGO Dolls House Sets | Argos',
    'interest:superheroes': 'LEGO Superheroes Sets | Argos'
  },
  30380: {
    'age-range:child-%281%252D2-years%29': 'Construction Toys for 1-2 Year Olds | Argos',
    'age-range:child-%285%252D8-years%29': 'Construction Toys for 5-7 Year Olds | Argos',
    'brands:gravitrax': 'Gravitrax | Argos',
    'brands:k%27nex': "K'NEX Toy Sets | Argos",
    'brands:lego': 'LEGO Construction Sets | Argos',
    'brands:magna%252Dtiles': 'Magna-Tiles Toys | Argos',
    'brands:mega-bloks': 'Mega Bloks | Argos',
    'brands:mega-pokemon': 'Mega Pokemon Sets | Argos',
    'brands:professor-puzzle': 'Professor Puzzle Construction Kits | Argos'
  },
  30381: {
    'character:ariel': 'Little Mermaid Ariel Dolls | Argos',
    'character:cocomelon': 'Cocomelon Dolls | Argos',
    'character:mulan': 'Mulan Dolls | Argos',
    'character:pocahontas': 'Pocahontas Dolls | Argos',
    'type:doll-playsets': 'Doll Playsets | Argos',
    'type:figures': 'Doll Figures | Argos',
    'type:plush-dolls': 'Plush Dolls | Argos'
  },
  30388: {
    'brands:tamagotchi': 'Tamagotchi | Argos'
  },
  30395: {
    'brands:photo-creator': 'Photo Creator | Argos',
    'brands:vtech': 'Vtech Cameras | Argos'
  },
  30397: {
    'brands:amazon': 'Amazon Fire Kids Tablets | Argos'
  },
  30411: {
    'brands:baby-born': 'Baby Born Styling Heads | Argos',
    'brands:monster': 'Monster High Makeup and Beauty Toys | Argos',
    'character:shimmer-n-sparkle-instaglam': 'Shimmer N Sparkle Instaglam | Argos'
  },
  30423: {
    'type:strategy-board-games': 'Strategy Board Games | Argos',
    'type:trivia-board-games': 'Trivia and Quiz Board Games | Argos',
    'type:word-board-games': 'Word Board Games | Argos'
  },
  30424: {
    'number-of-pieces:1000': '1000 Piece Jigsaws and Puzzles | Argos',
    'number-of-pieces:24': '24 Piece Jigsaws and Puzzles | Argos',
    'number-of-pieces:400': '400 Piece Jigsaws and Puzzles | Argos',
    'number-of-pieces:50': '50 Piece Jigsaws and Puzzles | Argos',
    'number-of-pieces:500': '500 Piece Jigsaws and Puzzles | Argos',
    'type:activity-games': 'Activity Games | Argos',
    'type:adult-jigsaw-puzzles': 'Adult Jigsaws and Puzzles | Argos',
    'type:jigsaw-storage': 'Jigsaw Puzzle Storage | Argos',
    'type:kids-jigsaw-puzzles': 'Kids Jigsaws and Puzzles | Argos'
  },
  30426: {
    'brands:barbie': 'Barbie Remote Control Cars | Argos',
    'brands:thomas-%26-friends': 'Thomas & Friends Remote Control Trains | Argos',
    'car-brand:lamborghini': 'Remote Control Lamborghinis | Argos'
  },
  30428: {
    'brands:hot-wheels/type:playsets': 'Hot Wheels Playsets | Argos'
  },
  42636: {
    'brands:designabear': 'DesignaBear Clothes and Accessories | Argos',
    'character:baby-carrier': 'Baby Doll Carriers | Argos',
    'type:doll-baby-walkers': 'Doll Baby Walkers | Argos',
    'type:doll-bathroom-furniture': 'Doll Baths and Bathroom Furniture | Argos',
    'type:doll-car-seats-and-carriers': 'Doll Car Seats | Argos',
    'type:doll-cars-and-vehicles': 'Doll Cars and Vehicles | Argos',
    'type:doll-changing-and-feeding': 'Doll Changing and Feeding Accessories | Argos',
    'type:doll-clothes-and-accessories': 'Doll Clothes | Argos',
    'type:doll-cots-and-beds': 'Doll Cots and Beds | Argos',
    'type:doll-highchairs': 'Doll Highchairs | Argos',
    'type:doll-wardrobes': 'Doll Wardrobes | Argos',
    'character:barbie/type:doll-cars-and-vehicles': 'Barbie Cars and Other Vehicles | Argos',
    'brands:designafriend/type:doll-clothes-and-accessories': 'DesignaFriend Clothes | Argos'
  },
  42640: {
    'brands:blo-pens': 'Blo Pens | Argos',
    'brands:chad-valley': 'Chad Valley Art Drawing Sets | Argos',
    'brands:crayola': 'Crayola Sets | Argos',
    'brands:paw-patrol': 'PAW Patrol Art Sets | Argos',
    'brands:peppa-pig': 'Peppa Pig Art Sets | Argos',
    'brands:pokemon': 'Pokemon Art Sets | Argos',
    'type:aqua-drawing-and-mechanical-drawing': 'Aqua Drawing Tools | Argos'
  },
  42641: {
    'brands:cra%252Dz%252Dslimy': 'Cra-Z-Slimy | Argos',
    'brands:kinetic-sand': 'Kinetic Sand | Argos',
    'brands:play%252Ddoh': 'Play-Doh Sets | Argos',
    'brands:so-slime': 'So Slime DIY and Sensations Kits | Argos',
    'type:slime': 'Slime Kits | Argos'
  },
  42642: {
    'brands:lego': 'LEGO Jewellery Boxes | Argos'
  },
  42643: {
    'brands:barbie': 'Barbie Arts and Crafts Kits | Argos',
    'brands:chad-valley': 'Chad Valley Art Sets | Argos',
    'brands:lite-brite': 'Lite Brite Toys | Argos',
    'brands:mr-frosty': 'Mr Frosty Sets | Argos',
    'brands:oonies': 'OONIES | Argos',
    'brands:pokemon': 'Pokemon Craft Kits | Argos',
    'brands:shrinky-dinks': 'Shrinky Dinks | Argos',
    'brands:style-4-ever': 'Style 4 Ever | Argos'
  },
  1000232: {
    'brands:lego': 'LEGO Sets Under £10 | Argos'
  },
  1028073: {
    'brands:lego': '2 for £15 LEGO Sets | Argos'
  }
}

export default pageTitles
